// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MgMK","label":"styles_label__gQeT8"};